
import { useQuery } from "@tanstack/react-query";
import { fetchProviderReviewsForUser } from "@/services/reviewService";
import { useAuth } from "@/contexts/auth";
import { transformReviewsForUI } from "./useReviewTransformer";
import { Review } from "@/types/supabase";

/**
 * A hook to fetch and manage reviews for a service provider
 * @param serviceId The ID of the service provider
 * @returns Query result containing reviews and loading state
 */
export function useServiceReviews(serviceId: string | undefined) {
  const { user, isAdmin } = useAuth();
  const viewerKey = user?.id ?? 'anonymous';

  return useQuery({
    queryKey: ['serviceReviews', serviceId, viewerKey, isAdmin],
    queryFn: async () => {
      if (!serviceId) return [];
      
      try {
        const reviewsWithProfiles = await fetchProviderReviewsForUser(serviceId, isAdmin);
        return transformReviewsForUI(reviewsWithProfiles as Review[]);
      } catch (error) {
        console.error("Error in useServiceReviews:", error);
        return [];
      }
    },
    enabled: !!serviceId,
  });
}

// Re-export the stats hook for backward compatibility
export { useReviewStats } from "./useReviewStats";
